import React, {useState} from "react";
import styled, {css} from "styled-components";

const Tooltip = (props) => {
    const [active, setActive] = useState(false)

    const showTip = () => {
        setActive(true)
    }

    const hideTip = () => {
        setActive(false)
    }

    return (
        <TooltipWrapper
            $mode={props.type}
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
            className={"tooltip"}>
            {props.children}
            {active &&
            <div className={`tooltip-tip ${props.direction || "top"}`}>
                {props.content}
            </div>
            }

        </TooltipWrapper>
    )
}

export default Tooltip

const TooltipWrapper = styled.div`
  /* Custom properties */

  /* Wrapping */

  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  //width: 100%;
  justify-content: center;
  
  ${(props) => {
      switch (props.$mode) {
        case "projectName":
            return css`
            width: 100%;
            `
        default: 
            return css`
            `;
      }
  }}


  /* Absolute positioning */

  .tooltip-tip {
    position: absolute;
    border-radius: 4px;
    left: 50%;
    transform: translateX(-50%);
    padding: 6px;
    color: var(--color-white);
    background: var(--color-black);
    font-size: 14px;
    font-family: sans-serif;
    line-height: 1;
    z-index: 1;
    white-space: nowrap;
  }

  /* CSS border triangles */

  .tooltip-tip::before {
    content: " ";
    left: 50%;
    border: 6px solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    margin-left: calc(6px * -1);
  }

  /* Absolute positioning */

  .tooltip-tip.top {
    top: calc(30px * -1);
  }

  /* CSS border triangles */

  .tooltip-tip.top::before {
    top: 100%;
    border-top-color: var(--color-black);
  }

  /* Absolute positioning */

  .tooltip-tip.right {
    left: calc(100% + 30px);
    top: 50%;
    transform: translateX(0) translateY(-50%);
  }

  /* CSS border triangles */

  .tooltip-tip.right::before {
    left: calc(6px * -1);
    top: 50%;
    transform: translateX(0) translateY(-50%);
    border-right-color: var(--color-black);
  }

  /* Absolute positioning */

  .tooltip-tip.bottom {
    bottom: calc(30px * -1);
  }

  /* CSS border triangles */

  .tooltip-tip.bottom::before {
    bottom: 100%;
    border-bottom-color: var(--color-black);
  }

  /* Absolute positioning */

  .tooltip-tip.left {
    left: auto;
    right: calc(100% + 30px);
    top: 50%;
    transform: translateX(0) translateY(-50%);
  }

  /* CSS border triangles */

  .tooltip-tip.left::before {
    left: auto;
    right: calc(6px * -2);
    top: 50%;
    transform: translateX(0) translateY(-50%);
    border-left-color: var(--color-black);
  }
`